export default __webpack_public_path__ + "static/media/nemesysco_v2.9d02579f.jpg";